import { SelectionModel } from '@angular/cdk/collections';
import { Component, Inject, OnInit, Optional } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { LocationService } from '../../location.service';
import { District } from 'app/masters/models/branch-master.model';

@Component({
  selector: 'app-search-district-master',
  templateUrl: './search-district-master.component.html',
  styleUrls: ['./search-district-master.component.scss']
})
export class SearchDistrictMasterComponent implements OnInit {
  dataSource = new MatTableDataSource<District>();
  selection = new SelectionModel<any>(true, []);
  displayedColumns: string[] = ['countryname','statename','districtname' ,'isActive'];
  showspinner = false;
  constructor(public dialog: MatDialog ,public locationService: LocationService,public dialogRef: MatDialogRef<SearchDistrictMasterComponent>, @Optional() @Inject(MAT_DIALOG_DATA) public data: any) {
    
   }

  ngOnInit(): void {
   this.dataSource.data=[];
    this.dataSource.filterPredicate = (data: any, filter: string) => {
    const dataStr = (data.countryName + data.stateName + data.districtname).toLowerCase();
    return dataStr.includes(filter);
  };
   this.getdistrictList();
  }
  getdistrictList() {  
    this.showspinner=true;
    this.locationService.getDistrict(0).subscribe(data => {
      this.dataSource.data=data;
      this.showspinner=false;
    },err=>{
      this.showspinner=false;
    });
  }
  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }


  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    return numSelected === numRows;
  }

  masterToggle() {
    this.isAllSelected() ?
      this.selection.clear() :
      this.dataSource.data.forEach(row => this.selection.select(row));
  }

  selectRow(row) {
    this.selection.toggle(row);
    this.dialogRef.close(row);
  }
  closedialog() {
    this.dialogRef.close();
  }
}
